import { useState } from 'react';

function RaiseRequestForm() {
    const [form, setForm] = useState({
        name: '',
        contact: '',
        address: '',
        queries: ''
    });

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const message = `Hello RP Smart Energy,%0A
*RAISE A REQUEST*%0A
Name: ${form.name}%0A
Contact: ${form.contact}%0A
Address: ${form.address}%0A
Queries: ${form.queries}`;

        const whatsappURL = `https://api.whatsapp.com/send?phone=919994356072&text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Raise a Request</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Contact Number</label>
                    <input
                        type="text"
                        name="contact"
                        className="form-control"
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                        name="address"
                        className="form-control"
                        rows="2"
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>

                <div className="mb-3">
                    <label className="form-label">Queries</label>
                    <textarea
                        name="queries"
                        className="form-control"
                        rows="3"
                        onChange={handleChange}
                        required
                    ></textarea>
                </div>

                <button type="submit" className="btn btn-primary">
                    Submit
                </button>
            </form>
        </div>
    );
}

export default RaiseRequestForm;